import { useMemo } from "react";

import type { IssueScope } from "#app/lib/filters/issue-scope";
import { useTeamDetail } from "#app/lib/hooks/use-team-detail";
import type { AssigneeRoster } from "./quick-inputs/quick-filter-options";

/**
 * The roster the Assignee pool splits on: the team a team screen is scoped
 * to. Every other scope has none, and the pool stays one flat list.
 *
 * Read from the team detail the screen's masthead already holds, cache-first,
 * so opening a filter never fetches a roster of its own.
 */
export function useAssigneeRoster(
  scope: IssueScope | undefined,
): AssigneeRoster | undefined {
  const teamId = scope?.kind === "team" ? scope.teamId : undefined;
  const { team } = useTeamDetail(teamId, { fetchPolicy: "cache-first" });

  return useMemo(() => {
    if (!team) return undefined;
    const memberIds = new Set(
      [...team.leads, ...team.members].map((user) => user.userId),
    );
    return { memberIds };
  }, [team]);
}
